<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:customizeActionAvailability="customizeActionAvailability"
			:modelColumnDefs="modelColumnDefs"
			:parentModel="parentModel"
			:parentModelName="parentModelName"
			:externalFilter="externalFilter"
			:readOnly="readOnly"
			:masterDetail="masterDetail"
			:showMasterDetailFilterListBtn="true"
			:showMasterDetailFilterBtn="true"
			:showMasterDetailSortBtn="true"
			:showMasterDetailConfBtn="true"
		></pui-datatable>
	</div>
</template>

<script>
import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import { STATUS_DRAFT_ID } from '../../constants/imofalforms/ImoFalFormsConstants';

export default {
	name: 'wastenotificationitems-grid',
	mixins: [PuiGridDetailMixin],
	components: {},
	data() {
		return {
			modelName: 'wastenotificationitems',

			modelColumnDefs: {},
			parentModelName: 'wastenotifications'
		};
	},
	methods: {
		customizeActionAvailability(actionId, parentModel) {
			if (actionId === 'puiImportAction' || actionId === 'puiExportAction') {
				return parentModel.status === STATUS_DRAFT_ID;
			}
		}
	}
};
</script>
